/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TaxCategoryAssociationListResponse } from '../../models/tax-category-association-list-response';

export interface TaxCategoriesAssociationsGet$Params {
  'Active-Tenant-Identifier': string;
  catalogEntryId?: string;
  taxCategoryId?: string;
  size?: number;
  page?: string;
}

export function taxCategoriesAssociationsGet(http: HttpClient, rootUrl: string, params: TaxCategoriesAssociationsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxCategoryAssociationListResponse>> {
  const rb = new RequestBuilder(rootUrl, taxCategoriesAssociationsGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('catalogEntryId', params.catalogEntryId, {});
    rb.query('taxCategoryId', params.taxCategoryId, {});
    rb.query('size', params.size, {});
    rb.query('page', params.page, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TaxCategoryAssociationListResponse>;
    })
  );
}

taxCategoriesAssociationsGet.PATH = '/tax-categories/associations';
